export default class MapMembers {
	constructor(el) {

		this.el = el;
		this.el.markers = document.querySelectorAll('[data-map-members-marker]');
		this.el.template = document.querySelector('[data-map-members-template]');

		const config = JSON.parse(this.el.dataset.hwcMapMembers);

		const view = L.map(this.el, {
			tap: true,
			gestureHandling: true,
		}).setView([config.center.lat, config.center.lng], 6);


		this.leafletMarkers = [];

		this.leafletCluster = L.markerClusterGroup({
			iconCreateFunction: function (cluster) {
				return L.divIcon({ html: '<span class="hwc-cluster">' + cluster.getChildCount() + '</span>' });
			}
		});

		const icon = L.icon({
			iconUrl: config.icon,
			iconSize: [32, 32],
			iconAnchor: [32 / 2, 32],
			popupAnchor: [0, 32 * -1],
		});

		this.map = {
			view: view,
			icon: icon,
		}

		L.tileLayer("https://tile.openstreetmap.org/{z}/{x}/{y}.png", {
			attribution:
				'&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors',
		}).addTo(this.map.view);

		this.setMarkers();
	}

	setMarkers() {

		this.el.markers.forEach(item => {
			this.setMarker(JSON.parse(item.dataset.mapMembersMarker));
		});

		let boundingBox = new L.featureGroup(this.leafletMarkers)
		let newBounds = boundingBox.getBounds()
		newBounds._nortEast += .5;
		newBounds._southWest -= .5;

		if (newBounds.isValid()) {
			this.map.view.fitBounds(newBounds);
		}

		this.map.view.addLayer(this.leafletCluster);
	}

	setMarker(marker) {

		let leafletMarker = L.marker(
			{
				lat: marker.lat,
				lng: marker.lng
			}, {
			icon: this.map.icon
		}
		)

		this.leafletMarkers.push(leafletMarker)

		this.leafletCluster.addLayer(leafletMarker);

		this.setPopup(marker, leafletMarker);
	}

	getPopup(marker) {

		let html_popup = document.importNode(this.el.template.content, true);

		let title = html_popup.querySelector('[data-map-members-template-title]');
		if (marker.title && title) {
			title.textContent = marker.title;
		} else {
			title.remove()
		}
		
		let tag = html_popup.querySelector('[data-map-members-template-tag]');
		if (marker.tag && tag) {
			tag.textContent = marker.tag;
		} else {
			tag.remove()
		}
		
		let adh_number = html_popup.querySelector('[data-map-members-template-adh-number]');
		if (marker.adh_number && adh_number) {
			adh_number.textContent = marker.adh_number;
		} else {
			adh_number.remove()
		}
		
		let desc = html_popup.querySelector('[data-map-members-template-desc]');
		if (marker.desc && desc) {
			desc.textContent = marker.desc;
		} else {
			desc.remove()
		}

		let address = html_popup.querySelector('[data-map-members-template-address]');
		if (marker.address && address) {
			address.textContent = marker.address;
		} else {
			html_popup.querySelector('.info-item.address').remove()
		}
		
		let tel = html_popup.querySelector('[data-map-members-template-phone]');
		if (marker.tel && tel) {
			tel.textContent = marker.tel;
		} else {
			html_popup.querySelector('.info-item.tel').remove()
		}
		
		let mail = html_popup.querySelector('[data-map-members-template-mail]');
		if (marker.mail && mail) {
			mail.textContent = marker.mail;
		} else {
			html_popup.querySelector('.info-item.mail').remove()
		}

		let link = html_popup.querySelector('[data-map-members-template-link]');
		//console.log(marker);
		
		if (marker.link && link && marker.title) {
			link.setAttribute('href', marker.link);
			link.setAttribute('title', marker.title);
		} else {
			link.remove();
		}

		return html_popup;

	}

	setPopup(marker, leafletMarker) {

		const html = this.getPopup(marker);
		let popupWrapper = document.createElement('div');
		popupWrapper.appendChild(html);
		leafletMarker.bindPopup(popupWrapper.innerHTML);

	}
}
